






















import { Component, Prop, Vue } from 'vue-property-decorator';
import ColorBox from './ColorBox.vue';

@Component({
  components: {
    'color-box': ColorBox,
  },
})
export default class ColorButton extends Vue {
  @Prop({ default: '' }) private currentColor!: string;

  @Prop({ default: '' }) private clickable!: boolean;

  @Prop({ default: () => [] }) private usedColors!: string[];

  modalX = 0;

  modalY = 0;

  showModal = false;

  select = '';

  open(e: MouseEvent): void {
    if (e.target instanceof Element) {
      if (this.clickable && e.target.matches('.color-button') && !this.showModal) {
        this.modalX = e.pageX;
        this.modalY = e.pageY;
        this.showModal = true;
      } else if (this.clickable && e.target.matches('.overlay') && this.showModal) {
        this.hideModal(this.currentColor);
      }
    }
  }

  hideModal(select: string): void {
    if (select) {
      this.showModal = false;
      this.select = select;
    }
  }

  changeColor(color: string): void {
    this.$emit('change-color', color);
  }
}
